import React, { useState } from 'react';
import { Box, Typography, Button, Collapse } from '@mui/material';

export interface FeatureDescriptionProps {
  shortText: string;
  longText: string;
}

/**
 * Compact header block: short summary (1–2 sentences) with a "Show more" control
 * that reveals longer copy. Used at the top of feature pages (Marketplace, TLC, B&B).
 */
const FeatureDescription: React.FC<FeatureDescriptionProps> = ({
  shortText,
  longText,
}) => {
  const [expanded, setExpanded] = useState(false);

  const paragraphs = longText
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean);

  return (
    <Box sx={{ mb: 1 }}>
      <Typography variant="body2" component="span" color="text.secondary">
        {shortText}{' '}
        <Button
          variant="text"
          color="primary"
          onClick={() => setExpanded(!expanded)}
          sx={{
            textTransform: 'none',
            p: 0,
            minWidth: 'auto',
            verticalAlign: 'baseline',
          }}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      </Typography>
      <Collapse in={expanded} timeout="auto">
        <Box sx={{ mt: 1 }}>
          {paragraphs.map((para, i) => (
            <Typography
              key={i}
              variant="body2"
              color="text.secondary"
              sx={{ mb: i < paragraphs.length - 1 ? 1 : 0 }}
            >
              {para}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
};

export default FeatureDescription;
